// extracted by mini-css-extract-plugin
export var centerText = "_6n-8";
export var container = "_6n-0";
export var doughnutContainer = "_6n-7";
export var legend = "_6n-a";
export var legendItemColorDisplay = "_6n-b";
export var legendItemLabel = "_6n-d";
export var legendItemValue = "_6n-c";
export var lg = "_6n-5";
export var maxWidth = "_6n-9";
export var md = "_6n-4";
export var responsive = "_6n-6";
export var sm = "_6n-3";
export var xs = "_6n-2";
export var xxs = "_6n-1";